import { Select } from 'foundations-components/transitional/components/Select';
import I18n from 'I18n';
import { useState } from 'react';
import { FormTypes } from '../../constants/form';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_PAGE_SIZE = 100;
const UPDATED_AT_DESC = '-updatedAt';
const VideoFormSelect = ({
  formInfo,
  selectedGuid,
  readOnly,
  fetchForms,
  onChange,
  trackVideoInteraction
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const loadOptions = (input = '', callback, pagination = {
    offset: 0
  }) => {
    let offset = pagination.offset;
    if (input !== searchTerm) {
      setSearchTerm(input);
      offset = 0;
    }
    const query = {
      name__contains: input,
      limit: DEFAULT_PAGE_SIZE,
      offset,
      formTypes: [FormTypes.HUBSPOT, FormTypes.VIDEO_FORM],
      order: UPDATED_AT_DESC
    };
    fetchForms(query).then(forms => {
      const options = forms.map(form => ({
        text: form.name,
        value: form.guid
      }));
      callback(null, {
        options
      });
    }).catch(err => {
      console.error('VideoFormSelect failed to fetch forms', err);
      callback(err);
    });
  };
  const handleChange = evt => {
    onChange(evt.target.value);
    trackVideoInteraction('select-video-form');
  };
  let initialOptions = [];
  if (formInfo && formInfo.name) {
    initialOptions = [{
      text: formInfo.name,
      value: formInfo.guid
    }];
  } else if (formInfo && formInfo.error) {
    initialOptions = [{
      text: I18n.text('RichTextLib.video.overlay.cannotFindForm'),
      value: selectedGuid
    }];
  } else if (selectedGuid) {
    initialOptions = [{
      text: I18n.text('RichTextLib.video.overlay.loadingOptions'),
      value: selectedGuid
    }];
  }
  return /*#__PURE__*/_jsx(Select, {
    buttonSize: "small",
    clearable: true,
    disabled: readOnly,
    loadOptions: loadOptions,
    options: initialOptions,
    onChange: handleChange,
    value: selectedGuid,
    "data-test-id": "video-form-select"
  });
};
export default VideoFormSelect;